import { Reducer } from "redux";
import { StatisticsState } from "../constants";
import { StatisticsActions, StatisticsActionTypes } from "../actions/types";

const initialState: StatisticsState = {
  playerStats: {},
  status: "idle",
  error: null,
};

const reducer: Reducer<StatisticsState> = (
  state = initialState,
  action: StatisticsActions
) => {
  switch (action.type) {
    case StatisticsActionTypes.FETCH_PLAYER:
      return { ...state, status: "loading" };

    case StatisticsActionTypes.FETCH_PLAYER_SUCCESS: {
      const { key, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        playerStats: {
          ...state.playerStats,
          [key]: { id: 0, response, fetchDate },
        },
      };
    }

    case StatisticsActionTypes.FETCH_ERROR_PLAYER:
      return { ...state, status: "failed", error: action.payload };

    default:
      return state;
  }
};

export { reducer as statisticsReducer };